import React, { useEffect } from 'react';

function MobileLayout({ layoutItems }) {
  // Helper function to find an item by its ID
  const findItemById = (id) => layoutItems.find((item) => item.id === id);

  // Recursive function to calculate spacing using mobile-specific properties
  const calculateTotalSpacing = (item, type) => {
    const mobileType = `mobile${type.charAt(0).toUpperCase() + type.slice(1)}`;
    const isActive = item[`${mobileType}Active`];
    const itemId = item[`${mobileType}ItemId`];
    const value = item[mobileType];

    if (!isActive) return null;
    if (!itemId) return Math.abs(value) || 0;

    const parentItem = findItemById(itemId);
    return parentItem ? value + calculateTotalSpacing(parentItem, type) : 0;
  };

  const renderItem = (item) => {
    const totalLeftSpacing = calculateTotalSpacing(item, 'left');
    const totalRightSpacing = calculateTotalSpacing(item, 'right');
    const totalTopSpacing = calculateTotalSpacing(item, 'top');
    const totalBottomSpacing = calculateTotalSpacing(item, 'bottom');

    const style = {
      position: 'absolute',
      top: totalTopSpacing !== null ? `${totalTopSpacing}px` : 'auto',
      left: totalLeftSpacing !== null ? `${totalLeftSpacing}px` : 'auto',
      right: totalRightSpacing !== null ? `${totalRightSpacing}px` : 'auto',
      bottom: totalBottomSpacing !== null ? `${totalBottomSpacing}px` : 'auto',
      width: item.mobileWidth ? `${item.mobileWidth}px` : 'auto',
      height: item.mobileHeight ? `${item.mobileHeight}px` : 'auto',
      backgroundColor: item.mobileBackgroundColor ? `#${item.mobileBackgroundColor}` : 'transparent',
      color: item.mobileForegroundColor ? `#${item.mobileForegroundColor}` : 'inherit',
      fontSize: item.mobileFontSize ? `${item.mobileFontSize}px` : 'inherit',
      zIndex: item.mobileZIndex !== undefined ? item.mobileZIndex : 'auto',
      borderWidth: item.mobileBorderWidth ? `${item.mobileBorderWidth}px` : '0',
      borderColor: item.mobileBorderColor ? `#${item.mobileBorderColor}` : 'transparent',
      borderRadius: item.mobileCornerRadius !== undefined ? item.mobileCornerRadius : 0,
    };

    switch (item.type) {
      case 0: // Symbol
        return <div key={item.id} style={style}><p>Symbol</p></div>;

      case 1: // Text
        return <div key={item.id} style={style}><p>{item.text}</p></div>;

      case 2: // Image
        return (
          <div key={item.id} style={style}>
            <img src={item.source} alt="" />
          </div>
        );

      case 3: // Video
        return (
          <video key={item.id} style={style} controls>
            <source src={item.source} />
          </video>
        );

      case 7: // Apple Music
        return (
          <div key={item.id} style={style}>
            <img
              src={item.appleMusicSongArtwork}
              alt="Song Artwork"
              style={{ width: '60px', height: '60px', objectFit: 'cover' }}
            />
            <div>
              <p>{item.appleMusicSongTitle}</p>
              <p>{item.appleMusicSongArtistName}</p>
              <p>{item.appleMusicSongAlbumName}</p>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="flex" style={{ position: 'relative' }}>
      {layoutItems.map((item) => renderItem(item))}
    </div>
  );
}

export default MobileLayout;
